import styled from "styled-components";
import { MainInner } from "@/styles/global";
import { FondCardPadding } from "@/styles/typography";

const AllocationWrapper = styled(MainInner)`
    ${FondCardPadding}
`;

const AllocationBarWrapper = styled.div`
  max-width: 300px;
  margin: 0 auto;
  margin-top: 20px;

  #allocationCircle {
    width: 100%;
  }
`;

const S = {
  AllocationWrapper,
  AllocationBarWrapper,
};

export default S;
